// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"_1w14A","backToDashboard":"_2TAC3"};